import React from "react";
import SellInfoEdit from "../sellerInformation/SellInfoEdit";
import VerifyInfoEdit from "./VerifyInfoEdit";
import BankDetailsEdit from "./BankDetailsEdit";
import StoreDetailsEdit from "./StoreDetailsEdit";

const EditProfile = ({ profiledate, HandleGEtsellerProfile }) => {
  return (
    <div>
      <div>
        <SellInfoEdit
          profiledate={profiledate}
          HandleGEtsellerProfile={HandleGEtsellerProfile}
        />
      </div>
      <div>
        <VerifyInfoEdit profiledate={profiledate} />
      </div>
      <div>
        <BankDetailsEdit profiledate={profiledate} />
      </div>
      <div>
        <StoreDetailsEdit profiledate={profiledate} HandleGEtsellerProfile={HandleGEtsellerProfile} />
      </div>
    </div>
  );
};

export default EditProfile;
